import React from "react";
import {
  SendDocumentReviewWorkspace,
  type SendDocumentReviewRequest,
} from "./SendDocumentReviewWorkspace";

/**
 * Der Seitenzustand zur Arbeitsfläche: Eine Seite, die Ruhezeit-, Kündigungs- oder freie
 * Schreiben anbietet, reicht `openDocumentReview` an die Fachdrawer weiter und rendert
 * `documentReviewWorkspace` an Stelle ihres Inhalts, solange es gesetzt ist. So zeigt jeder
 * Einstieg — Akte, Aufgaben, Posteingang, Interessenten — dieselbe Fläche.
 */
export function useSendDocumentReviewWorkspace(options?: { onSent?: () => void }) {
  const [request, setRequest] = React.useState<SendDocumentReviewRequest | null>(null);
  const onSentRef = React.useRef(options?.onSent);
  React.useEffect(() => {
    onSentRef.current = options?.onSent;
  }, [options?.onSent]);

  const documentReviewWorkspace = request ? (
    <SendDocumentReviewWorkspace
      {...request}
      open
      onCancel={() => {
        setRequest(null);
        request.onCancel();
      }}
      onSent={(result) => {
        setRequest(null);
        request.onSent(result);
        onSentRef.current?.();
      }}
    />
  ) : null;

  return { openDocumentReview: setRequest, documentReviewWorkspace };
}
